import React from 'react';
import ImageIcon from './imageIcon';
import LoadingIconDefault from './default';

const LoadingIcon = ({ src, primaryColor, secondaryColor }) => {
	return (
		<>
			{src ? (
				<ImageIcon src={src} />
			) : (
				<LoadingIconDefault
					ball1Color={primaryColor}
					ball2Color={secondaryColor}
					ball3Color={primaryColor}
					ball4Color={secondaryColor}
				/>
			)}
		</>
	);
};

export default LoadingIcon;
